import React from "react";

export const PoweredByWealthProLogo = ({ src, alt, ...rest }) => <img src="/images/wp-power-logo.png" alt="wealthpro" {...rest} />

const WealthProLogo = ({ src, alt, ...rest }) => <img src="/images/wp-logo.png" alt="wealthpro" {...rest} />

export default WealthProLogo;